module.exports = __webpack_public_path__ + "static/media/image_30.4af572c6.png";